import { render, staticRenderFns } from "./SignUpModal.vue?vue&type=template&id=87e1f04a&scoped=true&"
import script from "./SignUpModal.vue?vue&type=script&lang=js&"
export * from "./SignUpModal.vue?vue&type=script&lang=js&"
import style0 from "./SignUpModal.vue?vue&type=style&index=0&id=87e1f04a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e1f04a",
  null
  
)

export default component.exports